import {Injectable} from '@angular/core';
import {AccountingAccountDataService} from './accountingAccountData.service';
import {AccountingAccountModel} from '../../../api/entity/accountingAccount.model';
import {AccountingAccountConverter} from '../../../api/entity/converter/accountingAccount.converter';
import {AbstractDataServiceDtoAdapter} from '../../../../../core/service/v2/dataservice/adapter/abstractDataServiceDto.adapter';


@Injectable({providedIn: 'root'})
export class AccountingAccountDataServiceAdapter extends AbstractDataServiceDtoAdapter<AccountingAccountModel, AccountingAccountConverter> {
    constructor(dataService: AccountingAccountDataService, converter: AccountingAccountConverter) {
        super(dataService, converter);
    }
    newStoredEntityInstance(): AccountingAccountModel {
        return new AccountingAccountModel();
    }
}
